import { gql } from "@apollo/client";
import axios from "axios";
import { BASE_URL } from "../config/api_collection";
import { ERROR_API_NAME } from "../constants/variables";
import apolloClient from "../graphql";
import { SELL_SSR } from "../graphql/mutation";
import { GET_SSR_AVAILABILITY } from "../graphql/queries";
import { getToken } from "../helper/token";
import { errorHandingErrorMessage } from "../services/errrorHandling/errorHandling";

const BOOKING_SSRS_AVAILBILITY = `${BASE_URL}/api/ibe/booking/ssrs/availability`

export async function SsrAvailabilityRestAPI() {
  const url = `${BOOKING_SSRS_AVAILBILITY}`;
  const tokenHeaders = await getToken();
  tokenHeaders["Content-Type"] = "application/json";
  tokenHeaders.Accept = "application/json";

  const res = await axios.post(url, {}, { headers: tokenHeaders });

  return res.data;
}
export async function SsrAvailability() {
  try {
    const response = await apolloClient.query({
      query: GET_SSR_AVAILABILITY,
      variables: {},
      fetchPolicy: "no-cache"
    });
    // TODO :: need to remove the no-cache
    return response;
  } catch (error) {
    // calling Rest api as graphql failed;
    const restAPIResponse = await SsrAvailabilityRestAPI();
    const returndata = {
      data: {
        bookingBundleAvailability: restAPIResponse?.data?.bundles,
        ssrAvailabilityv2: restAPIResponse?.data?.ssrs
      }
    };
    return returndata;
  }
}

export interface sellSSRType {
  ssrKey: String,
  count: Number
}

export async function sellSsr(ssrKeyList: sellSSRType[]) {
  try {
    const response = await apolloClient.mutate({
      mutation: SELL_SSR,
      variables: {
        request: {
          feePricingMode: "MonetaryOnly",
          keys: ssrKeyList
        }
      }
    });
    return response;
  } catch (error) {
    console.warn("ssr api failed");
    return errorHandingErrorMessage(ERROR_API_NAME.SSR_SELL_API, error);
  }
}

export async function deleteSsr(ssrKey) {
  try {
    let ssrDeleteRequestsMutation = "";
    if (ssrKey && ssrKey.length > 0) {
      ssrKey.map(
        (key, index) =>
          (ssrDeleteRequestsMutation += `
      ssrDelete${index}: ssrsDelete(
        ssrKey: "${key}" 
        )`)
      );
      const deleteMutation = gql`mutation deleteSsrs {${ssrDeleteRequestsMutation}}`;
      const response = await apolloClient.mutate({
        mutation: deleteMutation,
        variables: {}
      });

      return response;
    }
    console.warn("No ssrKey found..");
    return false;
  } catch (error) {
    console.warn(error);
    return false;
  }
}
/*
SELLING INSU SSR, THIS IS A FEE CODE, 
*/
export async function sellTripCover(ssrCode) {
  try {
    const ssrDeleteRequestsMutation = "";

    if (ssrCode) {
      const sellTripCoverSsr = gql`mutation {
        feeAdd(request: { feeCode: "${ssrCode}" }) {
          code
          type
          passengerFeeKey
        }
      }`;
      const response = await apolloClient.mutate({
        mutation: sellTripCoverSsr,
        variables: {}
      });

      return response;
    }
  } catch (error) {
    console.warn(error);
  }
}

export async function sellBundle(sellableSsrByJourney, bundleCode) {
  try {
    const responses = [];

    const journeyKeys = Object.keys(sellableSsrByJourney);
    for (let ind = 0; ind < journeyKeys.length; ind++) {
      const journeyKey = journeyKeys[ind];
      const sellableSsrs = sellableSsrByJourney[journeyKey];
      const paxs = [];
      const ssrKeys = [];
      sellableSsrs.forEach(({ ssrKey, passengerKey }) => {
        paxs.push(passengerKey);
        ssrKeys.push({ ssrKey });
      });
  
      let bundleSellRequestsMutation = "";
      bundleSellRequestsMutation += `
                bundleSell(
                  journeyKey: "${journeyKey}"
                  request: { bundleCode: "${bundleCode}", passengerKeys: ${JSON.stringify(paxs)} }
                ) {
                  count
                  feeCode
                  inBundle
                  isConfirmed
                  isConfirmingUnheld
                  note
                  passengerKey
                  ssrCode
                  ssrDetail
                  ssrDuration
                  ssrDuration
                  ssrKey
                  ssrNumber
                  ssrNumber
                }
                `;
  
      const sellMutation = gql`mutation sell{
        ${bundleSellRequestsMutation}
      }`;
      const response = await apolloClient.mutate({
        mutation: sellMutation,
        variables: {
          request: {}
        }
      });
  
      responses.push(response);
    }
  
    return responses;
  
  } catch (error) {
    console.warn(error);
    return [];
  }
}
